import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';
import metrics from '../../../browser/metrics';

const ReadyToBuild = ({ ctaText, ctaLink, position }) => (
  <div className={styles.readyToBuild} >
    <span>
      Ready to start building?
    </span>

    <a href={ctaLink} onClick={() => metrics.track('click:readyToBuild', { trackData: position })}>
      <button className={`btn btn-success ${styles.readyToBuildButton}`}>
        {ctaText}
      </button>
    </a>
  </div>
);

ReadyToBuild.propTypes = {
  ctaText: PropTypes.string.isRequired,
  ctaLink: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired
};

ReadyToBuild.defaultProps = {
  ctaText: 'Go To Quickstart',
  ctaLink: '',
  position: ''
};


export default ReadyToBuild;
